import React, { Component } from 'react'
import { compose } from "redux"
import { withNamespaces } from "react-i18next"
import '../../i18n'
import './prefecture_properties.scss'
import PrefectureProperty from "./prefecture_property"

export class PrefectureProperties extends Component {
  propertyIds(prefecture) {
    return Object.keys(this.props.roomGroups[prefecture])
  }

  get numberOfPrefectureProperty() {
    return this.propertyIds(this.props.prefecture).length
  }

  render() {
    const {
      query,
      prefectureProperties,
      prefecture,
      propertyTypes,
      isSP
    } = this.props
    return (
      <section styleName="properties-wrapper">
        <h2 styleName="prefecture-heading">{prefecture}（{this.numberOfPrefectureProperty}件）</h2>
        {
          Object.keys(prefectureProperties).map((propertyId, index) => {
            return <PrefectureProperty
              key={index}
              isSP={isSP}
              query={query}
              propertyId={propertyId}
              prefecture={prefecture}
              propertyTypes={propertyTypes}
              roomGroups={prefectureProperties[propertyId]}
            />
          })
        }
      </section>
    )
  }
}

export default compose(
  withNamespaces()
)(PrefectureProperties)
